import React from 'react';
import { useNavigate } from 'react-router-dom';
import { categories } from '../styles/variables';

import jacquardImg    from '../images/jacquard.png.jpeg';
import dobbyImg       from '../images/dobbyweave.png.jpeg';
import plainImg       from '../images/plainweave.png.jpeg';
import terryImg       from '../images/terry.png.jpeg';
import dishclothImg   from '../images/dishcloth.png.jpeg';
import printedImg     from '../images/printed..png.jpeg';
import kitchensetImg  from '../images/kitchenset.png.jpeg';
import othersImg      from '../images/others.png.jpeg';

const imageMap = {
  'jacquard-weave':  jacquardImg,
  'dobby-weave':     dobbyImg,
  'plain-weave':     plainImg,
  'terry-kitchen':   terryImg,
  'dish-cloth':      dishclothImg,
  'printed-kitchen': printedImg,
  'kitchen-sets':    kitchensetImg,
  'others':          othersImg,
};

const getDisplayName = (cat) => {
  if (cat.id === 'plain-weave') return 'Flat Weave Kitchen Towels';
  return cat.name;
};

const Categories = () => {
  const navigate = useNavigate();

  return (
    <section id="categories" style={{ background: 'var(--color-cream, #FAF8F5)', padding: '2.5rem 0.5rem' }}>
      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
        <div style={{ fontFamily: "'Cinzel', serif", fontSize: '0.65rem', letterSpacing: '0.28em', textTransform: 'uppercase', color: '#B8965A', marginBottom: '0.9rem' }}>
          Our Collections
        </div>
        <h2 style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 'clamp(2rem, 3.5vw, 3rem)', fontWeight: 400, color: '#2C2C2C', marginBottom: '0.75rem' }}>
          Product Categories
        </h2>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', marginBottom: '1.25rem' }}>
          <div style={{ width: '48px', height: '1px', background: 'linear-gradient(90deg, transparent, #B8965A)' }} />
          <div style={{ width: '6px', height: '6px', background: '#B8965A', transform: 'rotate(45deg)' }} />
          <div style={{ width: '48px', height: '1px', background: 'linear-gradient(90deg, #B8965A, transparent)' }} />
        </div>
        <p style={{ fontFamily: "'Jost', sans-serif", fontSize: '1rem', fontWeight: 300, color: '#6B6B6B', maxWidth: '480px', margin: '0 auto', lineHeight: 1.7 }}>
          Eight distinct product lines crafted to meet the highest international export standards.
        </p>
      </div>

      {/* Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1rem', maxWidth: '1700px', margin: '0 auto' }}>
        {categories.map((cat) => (
          <CategoryCard
            key={cat.id}
            cat={cat}
            img={imageMap[cat.id]}
            onClick={() => navigate(`/category/${cat.id}`)}
          />
        ))}
      </div>

      <style>{`
        @media (max-width: 1024px) {
          #categories > div:last-of-type { grid-template-columns: repeat(2, 1fr) !important; }
        }
        @media (max-width: 600px) {
          #categories > div:last-of-type { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
};

const CategoryCard = ({ cat, img, onClick }) => {
  const [hovered, setHovered] = React.useState(false);

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        cursor: 'pointer',
        borderRadius: '16px',
        overflow: 'hidden',
        background: '#fff',
        boxShadow: hovered ? '0 20px 50px rgba(0,0,0,0.13)' : '0 4px 20px rgba(0,0,0,0.07)',
        transform: hovered ? 'translateY(-6px)' : 'translateY(0)',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ width: '100%', aspectRatio: '4/3', overflow: 'hidden', position: 'relative' }}>
        <img
          src={img}
          alt={getDisplayName(cat)}
          style={{ width: '100%', height: '100%', objectFit: 'cover', transform: hovered ? 'scale(1.07)' : 'scale(1)', transition: 'transform 0.5s ease', display: 'block' }}
        />
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(184,150,90,0.15)', opacity: hovered ? 1 : 0, transition: 'opacity 0.3s ease' }} />
      </div>

      <div style={{ padding: '1.25rem 1.5rem 1.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '1.15rem', fontWeight: 600, color: '#2C2C2C', lineHeight: 1.3 }}>
          {getDisplayName(cat)}
        </div>
        <div style={{ fontFamily: "'Jost', sans-serif", fontSize: '0.75rem', fontWeight: 500, letterSpacing: '0.08em', textTransform: 'uppercase', color: hovered ? '#B8965A' : '#999', transition: 'color 0.2s ease', display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
          View Products
          <span style={{ transform: hovered ? 'translateX(4px)' : 'translateX(0)', transition: 'transform 0.2s ease', display: 'inline-block' }}>&#8594;</span>
        </div>
      </div>
    </div>
  );
};

export default Categories;